/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from "styled-components";
import Colors from 'constants/Colors';
import { FontWeight, FiraSansBold } from 'components/Text';
import { Breakpoints } from "constants/Breakpoints";
  
  export const DialogSelect = styled.div`
  width: 100%;  
`;

  export const DialogConfirm = styled.button`
  width: calc(50% - 10px);
  margin-left: 10px;
  height: 40px;
  background: ${Colors.BLUE};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
`;

export const TextArea = styled.textarea`
width:100%;
min-height: 120px;
height:auto;
padding:15px;
border:2px solid ${Colors.GRAY[3]};
border-radius:8px;
resize:none;
font-family: Courier, monospace;
font-weight: ${FontWeight.SemiBold};
color: ${Colors.GRAY[6]};
font-size:14px;
`;

export const DialogCancel = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[0]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;
export const Footer = styled.div`
display: flex;
justify-content: space-between;
margin-top: 20px;  
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px 0px 0px;
`;

export const ButtonContent = styled.div`
    display:flex;
    flex-direction: row;
    background-color:#FFF; 
    justify-content: space-evenly;
    
    @media (max-width: ${Breakpoints.lg}) {  
      flex-wrap: wrap;
      padding-right: 10px;
      width: 100%;
    }
`;